import React, {useEffect} from 'react';
import {logPageLoadEvents} from '@ibibo/analytics';
import {userDataSelector, prevPageNameSelector} from '../../store/selectors';
import {useSelector, useDispatch} from 'react-redux';

import OtpVerify from './containers/OtpVerify';
import {updatePreviousPageName} from '../../store/actions'

import Onboarding from '../../stories/components/Onboarding/onboarding';

const VerifyPage = () => {
  const userInfo = useSelector(userDataSelector);
  const { email, mobile } = userInfo;
  const data = useSelector(prevPageNameSelector);
  const {prevPageName} = data;
  const dispatch = useDispatch();
  
  useEffect(() => {
    const events = {
      eVar34: email,
      eVar35: mobile,
      eVar23: prevPageName,
      eVar24: "onboarding|mypartner",
      eVar37: "domain_sbu:india|domain_country:in|domain_currency:inr|domain_language:eng",
    }
    logPageLoadEvents('onboarding:otpvalidation', events);
    dispatch(updatePreviousPageName("onboarding:otpvalidation"));
  }, [dispatch]);

  return (
    <Onboarding step={2}>
      <OtpVerify />
    </Onboarding>
  );
};

export default VerifyPage;
